export default __webpack_public_path__ + "static/media/Disconnected.6419fa24.svg";